import { Component } from "@angular/core";
import { environment } from "../environments/environment";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  myScriptElement: HTMLScriptElement;

  constructor() {
    this.myScriptElement = document.createElement("script");
    this.myScriptElement.src = `${environment.TEMP_API_URL}clients/paymentFields.min.js`;
    document.body.appendChild(this.myScriptElement);
  }
}
